
import React, { useCallback, useRef } from 'react';
import { Alert, Box, Button, DialogActions, DialogContent, DialogTitle, FormControl, Grid, InputLabel, LinearProgress, MenuItem, Paper, Select, SelectChangeEvent, TextField } from '@mui/material';
import { useState } from 'react';
import Snackbar, { SnackbarCloseReason } from '@mui/material/Snackbar';
import { AutoCompleteProdutos } from '../../../shared/forms';
import { PedidoDiretoService } from '../../../shared/services/api/vendas/pedidodireto/PedidoDiretoService';
import { IEtiquetas, ProdutosService } from '../../../shared/services/api/cadastros/ProdutosService';
import REtiquetas from './REtiquetas3';

export const Etiquetas: React.FC = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [uuidfabrica, setUidfabrica] = useState('');
  const [nome, setnome] = useState('');
  const [msg, setMsg] = useState('');
  const [openalert, setOpenAlert] = useState(false);
  const [tipo, setTipo] = useState('p.ean');
  const [codigobarra, setcodigobarra] = useState('');
  const codigoref = useRef<HTMLInputElement>(null);
  const [quantidade, setQuantidade] = useState(3);
  const [uuidprod, setUuidprod] = useState('');
  const [produto, setProduto] = useState<IEtiquetas>({
    descricao: '',  
    ean: '',                         
    fabrica: ''                       
  });                                                
                 
  const handleSave = () => {
    const results = Array.from({ length: quantidade * 1 }, () => ({
      descricao: produto.descricao,
      ean: produto.ean,
      fabrica: produto.fabrica
    }));                   
    REtiquetas(results);                
  };        
  const handleCloseAlert = (
    event?: React.SyntheticEvent | Event,
    reason?: SnackbarCloseReason,
  ) => {   
    if (reason === 'clickaway') {
      return;
    }
    setOpenAlert(false);    
  };             
  const handleChange = (event: SelectChangeEvent) => {
    setTipo(event.target.value as string);
  };

  const handleuuidProd = (uuid: string | undefined) => {
    if (uuid != null) {
      setUuidprod(uuid);
      setIsLoading(true);
      try {   
        ProdutosService.Etiquetas(tipo, uuid)
          .then((result) => {
            setIsLoading(false);
            if (result instanceof Error) {
              setMsg(result.message)
              setOpenAlert(true);
            } else {   
              setProduto(
                {
                  descricao: result.descricao,
                  ean: result.ean,
                  fabrica: result.fabrica
                }   
              )         
            }
          });
      } catch (error: any) {
        setIsLoading(false);
        setMsg(error.message)
        setOpenAlert(true);
        setTimeout(() => {
          codigoref.current?.focus();
        }, 0);
      }
    }     
  };

  const handlebusca = useCallback(async (codigobarra: any) => {
    setIsLoading(true);
    try {
      // PedidoDiretoService.getProdutos(tipo, uuidcli, codigobarra)
      //   .then((result) => {
      //     setIsLoading(false);
      //     if (result instanceof Error) {
      //       setMsg(result.message);
      //       setOpenAlert(true);
      //     } else {   
      //       handleItens({   
      //         iditens: uuidv4(),       
      //         idprod: result.idprod,
      //         idfabrica: result.idfabrica,
      //         quantidade: Number(quantidade),
      //         preco: result.preco,
      //         total: result.preco * Number(quantidade),
      //         descricao: result.descricao,
      //         codfabrica: result.codfabrica,
      //         ean: result.ean,
      //         nome: result.nome,
      //         un: result.un,
      //       })
      //     }
      //     setcodigobarra('');
      //  });
      setIsLoading(false);
      setTimeout(() => {
        codigoref.current?.focus();
      }, 0);

    } catch (error: any) {
      setIsLoading(false);
      setMsg(error.message)
      setOpenAlert(true);
      setTimeout(() => {
        codigoref.current?.focus();
      }, 0);
    }
  }, [codigobarra]);


  return (
    <Box alignItems="center" width='auto' alignContent='center' height="auto" display="flex" flexDirection="column"  >
      <Snackbar
        open={openalert}
        autoHideDuration={1200}
        onClose={handleCloseAlert}
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      >
        <Alert
          onClose={handleCloseAlert}
          severity="error"
          variant="filled"
          sx={{ width: '100%' }}  
        >               
          {msg}         
        </Alert>               
      </Snackbar>
      <Box gap={1} padding={1} paddingX={2} display="flex" alignItems="center" alignSelf='center' width='80%' height="20%" margin={1} alignContent='center'></Box>
      <Box width='37%' alignItems="center" component={Paper} height="auto" margin={1}
        alignContent='center'>
        <DialogTitle>Etiquetas</DialogTitle>
        <DialogContent dividers>
          {isLoading && (                 
            <Grid item>
              <LinearProgress variant='indeterminate' />
            </Grid>     
          )}                     
          <FormControl>
            <InputLabel id="demo-simple-select-label">Tipo Pesquisa</InputLabel>
            <Select
              sx={{ marginBottom: 2, width: '30ch' }}
              size='small'  
              value={tipo}
              label='Tipo Pesquisa'                   
              onChange={handleChange}
            >
              <MenuItem value={'p.ean'}>Código de Barras</MenuItem>
              <MenuItem value={'p.idprod'}>Descrição</MenuItem>
              <MenuItem value={'p.codfabrica'}>Referência</MenuItem>
            </Select>                         
          </FormControl>                                                                           
          <TextField                             
            sx={{ marginLeft: 1, marginBottom: 2, width: '11ch' }}
            type='number'   
            value={quantidade}                        
            disabled={isLoading}       
            onChange={(e) => { setQuantidade(Number(e.target.value))}}
            size='small'
            label='Quantidade'     
          />                                     
          {tipo === 'p.ean' && (                  
            <TextField                                            
              sx={{ width: '46ch' }}      
              size='small'     
              value={codigobarra}
              label='Código de Barras'
              inputRef={codigoref}
              disabled={isLoading}
              onChange={e => setcodigobarra(e.target.value)}
              onKeyDown={(e) => {
                if (e.key === 'Enter' && codigobarra.trim() !== '') {
                  handlebusca(codigobarra);
                }
              }}                 
            />          
          )}       
          {tipo === 'p.codfabrica' && (
            <TextField   
              sx={{ width: '46ch' }}
              size='small'                     
              value={codigobarra}        
              label='Referência'           
              inputRef={codigoref}    
              disabled={isLoading}
              onChange={e => setcodigobarra(e.target.value)}
              onKeyDown={(e) => {
                if (e.key === 'Enter' && codigobarra.trim() !== '') {
                  handlebusca(codigobarra);
                }
              }}                          
            />     
          )}    
          {tipo === 'p.idprod' && (
            <AutoCompleteProdutos
              isExternalLoading={isLoading}
              uuidprod={handleuuidProd}
            />
          )}     
        </DialogContent>     
        <DialogActions>
          <Button sx={{ minWidth: '30%' }} variant='outlined' autoFocus onClick={handleSave}>Visualizar</Button>
        </DialogActions>        
      </Box>
    </Box>
  );
};   